/**
 * StayOn-Icon-Set — Legacy-Wrapper. DEPRECATED ab Sprint 16.
 *
 * Neue Konvention: direkt aus `lucide-react` importieren, kein Alias-Layer.
 *   import { Building } from 'lucide-react';
 *   <Building size={16} />
 *
 * Dieser Wrapper bleibt temporär grün, damit die 64 bestehenden Konsumer
 * nicht in einem Big-Bang-Sweep migriert werden müssen. Shared-Components
 * migrieren in Issue F, Feature-Files in Codemod am Ende von Issue J.
 *
 * Sprint-16-Brand-Change: Stroke-Width-Default von 1.6 auf 2 (Design-System
 * 4h_2 Config: "lucide · stroke 2 · 16-20px"). Damit sehen die 64
 * Legacy-Konsumer sofort korrekt aus ohne einzelne Migration.
 */
import type { LucideProps } from 'lucide-react';
import {
  Archive,
  AlertCircle,
  AlertTriangle,
  ArrowLeft,
  ArrowRight,
  Bath,
  Bed,
  Bell,
  Building2,
  Calendar,
  CalendarDays,
  ChartNoAxesCombined,
  Check,
  ChevronDown,
  ChevronRight,
  Copy,
  Database,
  ReceiptText,
  Download,
  Edit,
  ExternalLink,
  Eye,
  EyeOff,
  Globe,
  Heart,
  Inbox,
  Info,
  Key,
  Loader2,
  Pause,
  Play,
  Lock,
  LogOut,
  Mail,
  MapPin,
  Menu,
  Minus,
  Phone,
  Plus,
  RefreshCw,
  Search,
  Settings,
  Shield,
  SlidersHorizontal,
  Sparkles,
  Square,
  Star,
  Trash2,
  Upload,
  Users,
  Webhook,
  Wifi,
  X,
  Zap,
} from 'lucide-react';

/* ─── Aliases — matchen die Namen der Buchungsseite ──────────────────────── */
export const Icon = {
  // Brand + Booking-Seite-Aliases
  Search,
  Pin: MapPin,
  Cal: Calendar,
  Users,
  Bed,
  Bath,
  Square,
  Wifi,
  Key,
  Check,
  Arrow: ArrowRight,
  ArrowLeft,
  Close: X,
  Menu,
  Plus,
  Minus,
  Chevron: ChevronRight,
  ChevronDown,
  Sliders: SlidersHorizontal,
  Heart,
  Phone,
  Mail,
  Globe,
  Lock,
  Bolt: Zap,
  Shield,
  Sparkle: Sparkles,
  Star,
  // Admin-Ergänzungen — Booking-Seite hat sie nicht, wir brauchen sie
  Archive,
  Edit,
  Trash: Trash2,
  Eye,
  EyeOff,
  Settings,
  Bell,
  LogOut,
  Copy,
  ExternalLink,
  Download,
  Upload,
  Refresh: RefreshCw,
  Info,
  Warning: AlertTriangle,
  Error: AlertCircle,
  Database,
  Building: Building2,
  CalendarDays,
  Chart: ChartNoAxesCombined,
  Receipt: ReceiptText,
  Webhook,
  Inbox,
  Loader: Loader2,
  Pause,
  Play,
} as const;

export type IconName = keyof typeof Icon;
export type IconComponent = (typeof Icon)[IconName];

/**
 * Universeller Icon-Wrapper — DEPRECATED, direkter lucide-react-Import bevorzugt.
 * Default-Stroke ab Sprint 16: 2 (Design-System 4h_2).
 * Verwendung: `<I name="Search" size={16} />`
 */
export interface IProps extends Omit<LucideProps, 'ref'> {
  name: IconName;
}

export function I({ name, strokeWidth = 2, size = 18, ...rest }: IProps) {
  const Component = Icon[name];
  return <Component strokeWidth={strokeWidth} size={size} {...rest} />;
}

/**
 * Ziehgriff sortierbarer Zeilen. Lucide hat kein Punkteraster in dieser Dichte; die Form stammt
 * aus dem Design-System und lag bis Sprint 55 zweimal identisch im Feature-Code (wiederkehrende
 * Posten, Positionskatalog). Hier liegt sie einmal — der dritte Sortierbereich erbt sie.
 */
export function GripDotsIcon() {
  return (
    <svg
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="3" cy="3" r="1.2" fill="currentColor" />
      <circle cx="9" cy="3" r="1.2" fill="currentColor" />
      <circle cx="3" cy="7" r="1.2" fill="currentColor" />
      <circle cx="9" cy="7" r="1.2" fill="currentColor" />
      <circle cx="3" cy="11" r="1.2" fill="currentColor" />
      <circle cx="9" cy="11" r="1.2" fill="currentColor" />
    </svg>
  );
}
